<div class="stock-wrapper bg-black min-vh-100">
  <div class="row mx-auto">
    <div class="col-md-12 my-5">
      <div class="form-row form-group">
        <div class="col-md-3">
          <div class="row">
            <div class="col-md-8">
              <select class="form-control bg-dark border-secondary text-light" (change)="channelChange($event)">
                <option [selected]="item?.chanel_id == channelId" [value]="item?.chanel_id"
                  *ngFor="let item of channelList">
                  {{ item?.chanel_name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="d-flex justify-content-around bg-dark border border-secondary rounded">
            <div>
              <select id="type" class="form-control bg-dark border-0 text-light" (change)="typeChange($event)">
                <option value="video">Videos</option>
                <option value="image">Images</option>
                <option value="font">Fonts</option>
              </select>
            </div>
            <div class="flex-fill">
              <input id="text-search" type="text" class="form-control bg-dark border-0 text-light"
                placeholder="Type something" value="" (keyup.enter)="search($event)">
            </div>
            <div class="div-select-video">
              <select id="select-canva-cate" class="form-control bg-dark border-0 text-light"
                (change)="canvaSelectChange($event)">
                <option value="">Category</option>
                <option [value]="item" *ngFor="let item of videoCanvaCateList">{{ item }}</option>
              </select>
            </div>
            <div class="div-select-font hidden">
              <select class="form-control bg-dark border-0 text-light" (change)="canvaSelectChange($event)">
                <option value="">Locale</option>
                <option [value]="item.code" *ngFor="let item of localeList">{{ item.name }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-3"></div>
      </div>
    </div>
  </div>

  <div class="row mx-auto">
    <div class="col-md-2 div-select-video vid_selected">
      <img id="vid_{{item?.id}}" *ngFor="let item of videoCanvaSelected" class="choose" src="{{item?.poster}}"
        (dblclick)="selectedCanva(item)">
    </div>
    <div class="col-md-2 div-select-image img_selected hidden">
      <img id="img_{{item?.id}}" *ngFor="let item of imageCanvaSelected" class="choose" src="{{item.poster}}"
        (dblclick)="selectedCanva(item)">
    </div>
    <div class="col-md-2 div-select-font fon_selected hidden">
      <img id="fon_{{item?.id}}" *ngFor="let item of fontCanvaSelected" class="choose" src="{{item?.poster}}"
        (dblclick)="selectedCanva(item)">
    </div>

    <div class="col-md-10 vid_selecting">
      <div class="row mx-auto div-select-video" *ngIf="videoCanvaList?.results.length > 0">
        <div class="col-md-3 p-2 c-pointer" *ngFor="let item of videoCanvaListLast">
          <img id="video_{{item?.id}}" class="image p-0 col-md-12 {{item.selected}}" [src]="item?.poster"
            attr.data-poster="{{item.listPoster}}" (mouseover)="mouseOverPlay(item)">
          <i id="i_{{item?.id}}"></i>
        </div>
        <button type="button" class="btn btn-block btn-secondary my-3" *ngIf="videoCanvaList?.page != -1"
          (click)="loadMore(videoCanvaList?.page)">Load more</button>
      </div>

      <div class="row mx-auto div-select-image" *ngIf="imageCanvaList?.results.length > 0">
        <div class="col-md-3 p-2" *ngFor="let item of imageCanvaListLast">
          <img id="image_{{item.id}}" src="{{item.poster}}" class="image p-0 col-md-12 {{item.selected}}"
            title="{{item.size}}" (click)="selectedCanva(item)" />
        </div>
        <button type="button" class="btn btn-block btn-secondary my-3" *ngIf="imageCanvaList?.page != -1"
          (click)="loadMore(imageCanvaList?.page)">Load more</button>
      </div>

      <div class="row mx-auto div-select-font" *ngIf="fontCanvaList?.results.length > 0">
        <img *ngFor="let item of fontCanvaListLast" id="font_{{item.id}}" class="font-image {{item.selected}}"
          src="{{item.poster}}" title="{{item.title}}" (click)="selectedCanva(item)" />
        <button type="button" class="btn btn-block btn-secondary my-3" *ngIf="fontCanvaList?.page != -1"
          (click)="loadMore(fontCanvaList?.page)">Load more</button>
      </div>
    </div>
  </div>

  <!-- <ng-template #nodata><div class= "row mx-auto text-center" >No data found</div></ng-template> -->
</div>
